import React, { useEffect, useState } from "react";
import api, { brl, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Loader2, RotateCcw, Trash2 } from "lucide-react";
import { toast } from "sonner";

export function LixeiraContratos({ onRestored }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/lixeira/contratos"); setItems(data); } catch { /* ignorado */ }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const restore = async (t) => {
    try {
      await api.post(`/lixeira/contratos/${t.id}/restaurar`);
      toast.success(`Contrato ${t.numero} restaurado`);
      load(); onRestored && onRestored();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao restaurar"); }
  };
  const purge = async (t) => {
    try {
      await api.delete(`/lixeira/contratos/${t.id}`);
      toast.success("Excluído definitivamente");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  return (
    <div className="trt-card overflow-hidden" data-testid="lixeira-contratos">
      <div className="px-4 py-3 border-b text-sm text-slate-500 flex items-center gap-2">
        <Trash2 className="w-4 h-4" /> Contratos excluídos ficam aqui por 30 dias e depois são apagados automaticamente.
      </div>
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
          <tr><th className="text-left px-4 py-3">Contrato</th><th className="text-left px-4 py-3">Cliente</th>
            <th className="text-left px-4 py-3 hidden md:table-cell">Valor</th><th className="text-left px-4 py-3 hidden lg:table-cell">Excluído em</th>
            <th className="text-left px-4 py-3">Expira</th><th className="px-2 py-3"></th></tr>
        </thead>
        <tbody>
          {loading ? <tr><td colSpan={6} className="py-10 text-center"><Loader2 className="w-6 h-6 animate-spin gold-text mx-auto" /></td></tr>
            : items.length === 0 ? <tr><td colSpan={6} className="py-10 text-center text-slate-400">Lixeira vazia.</td></tr>
            : items.map((t) => (
              <tr key={t.id} className="border-t" data-testid={`trash-row-${t.id}`}>
                <td className="px-4 py-3 font-semibold mono">{t.numero} <span className="ml-1"><StatusBadge status={t.status} /></span></td>
                <td className="px-4 py-3">{t.cliente_nome}</td>
                <td className="px-4 py-3 hidden md:table-cell font-bold">{brl(t.valor_total)}</td>
                <td className="px-4 py-3 hidden lg:table-cell text-slate-500">{fmtDate(t.deleted_at)} • {t.deleted_by}</td>
                <td className="px-4 py-3 text-slate-500">{t.dias_restantes} dia(s)</td>
                <td className="px-2 py-3">
                  <div className="flex justify-end gap-1">
                    <Button size="sm" variant="outline" className="gap-1" onClick={() => restore(t)} data-testid={`trash-restore-${t.id}`}><RotateCcw className="w-4 h-4" /> Restaurar</Button>
                    <AlertDialog>
                      <AlertDialogTrigger asChild><Button size="sm" variant="ghost" className="text-red-600 hover:bg-red-50" data-testid={`trash-purge-${t.id}`}><Trash2 className="w-4 h-4" /></Button></AlertDialogTrigger>
                      <AlertDialogContent>
                        <AlertDialogHeader><AlertDialogTitle>Excluir definitivamente {t.numero}?</AlertDialogTitle>
                          <AlertDialogDescription>Contrato, parcelas, pagamentos e acordos serão apagados para sempre.</AlertDialogDescription></AlertDialogHeader>
                        <AlertDialogFooter><AlertDialogCancel>Cancelar</AlertDialogCancel>
                          <AlertDialogAction onClick={() => purge(t)} className="bg-red-600 hover:bg-red-700" data-testid={`trash-purge-confirm-${t.id}`}>Excluir</AlertDialogAction></AlertDialogFooter>
                      </AlertDialogContent>
                    </AlertDialog>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
